import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import DateCommon from '../../../CommonV2/Date';

/**
 * FieldInput
 * @param {*} param0
 */
const FieldDate = ({ code, disabled, existError, showError, validate, handleBlur, param }) => (
  <Field
    component={DateCommon}
    name={code}
    disabled={disabled}
    existError={existError}
    showError={showError}
    validate={validate}
    eventEmitter={v => handleBlur(v)}
    min={param.min}
    max={param.max}
  />
);

FieldDate.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  param: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
  }),
};
FieldDate.defaultProps = {
  disabled: false,
  param: {},
};

export default connect(FieldDate);
